module.exports = __webpack_public_path__ + "images/shoebox3-10e807a452de72fb203e919a944f09a8.png";